import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Delete, Pen, Settings } from "lucide-react";
import Swal from "sweetalert2";
import { deleteBranchUser, fetchBranchUsers } from "../../../slices/company/branchUserSlice";
import ChangePasswordModal from "./change_password";
import { customTableStyles } from "../../../utils/tableStylings";

const BranchUser = () => {
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedUser, setSelectedUser] = useState([]); // To control modal visibility
    // Retrieve branches data and loading/error states from the Redux store
    const { branchUsers, loading, error } = useSelector((state) => state.branchUsers);

    useEffect(() => {
        // Fetch branches when the component mounts
        dispatch(fetchBranchUsers());
    }, [dispatch]);


    const handleDelete = (branchId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this User.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteBranchUser(branchId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The User has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });
                
            }
        });
       
    };

    const handleFormSubmit = (formData) => {

    }
    // Define table columns
    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1, // Display row index (1-based)
            sortable: false,
            width: "50px",
        },
        {
            name: "Employee Id",
            selector: (row, index) => `#${row.emp_id}`, // Display row index (1-based)
            sortable: false
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row.email || 'N/A',
            sortable: true,
        },
        {
            name: "Phone",
            selector: (row) => row.mobile_no || 'N/A',
            sortable: true,
        },
        {
            name: "Branch",
            selector: (row) => row.branch?.branch_name || 'N/A',
            sortable: true,
        },
        {
            name: "Role",
            selector: (row) => row.role?.name || 'N/A',
            sortable: true,
        },
        {
            name: "Actions",
            width: "200px",
            cell: (row) => (
                <div>
                    <Link
                        className="text-warning me-2"
                        to={'/branch/users/edit'}
                        state={{branchUserData: row}}
                    >
                        <Pen/>
                    </Link>

                    <Link
                        className="text-danger me-2"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete/>
                    </Link>
                    <Link
                        className="text-secondary me-2"
                        onClick={() => handleChangePassword(row)}
                    >
                        <Settings/>
                    </Link>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleChangePassword = (row) => {
        setSelectedUser(row);
        setShowModal(true);
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="text-primary">Users / Staff</h3>
                            <Link to={'/branch/users/add'} className="btn btn-primary">Add New</Link>
                        </div>
                        <div className="card-body">
                        
                            <div className="table-responsive">
                                <DataTable
                                    className="table-hover custom-table"
                                    columns={columns}
                                    data={branchUsers} // Use filtered data
                                    pagination
                                    striped
                                    progressPending={loading}
                                    customStyles={customTableStyles}
                                />
                            </div>

                            {/* Error Message */}
                            {error && <p className="text-danger mt-2">Error: {error}</p>}
                        </div>
                    </div>
                </div>
            </div>
            <ChangePasswordModal show={showModal} onClose={() => setShowModal(false)} heading={'Change Password'} initialData={selectedUser} onSubmit={handleFormSubmit} />
        </>
    );
}

export default BranchUser;
